module.exports = __webpack_public_path__ + "static/img/rank_227.242a5f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_227.png
// module id = z5LI
// module chunks = 1